/* tslint:disable */

/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ReadResourceResponse
 */
export interface ReadResourceResponse {
	/**
	 * RID of the resource
	 * @type {string}
	 * @memberof ReadResourceResponse
	 */
	rID: string;
	/**
	 * State information of the resource
	 * @type {object}
	 * @memberof ReadResourceResponse
	 */
	state: object;
}

/**
 * Check if a given object implements the ReadResourceResponse interface.
 */
export function instanceOfReadResourceResponse(value: object): boolean {
	let isInstance = true;
	isInstance = isInstance && 'rID' in value;
	isInstance = isInstance && 'state' in value;

	return isInstance;
}

export function ReadResourceResponseFromJSON(json: any): ReadResourceResponse {
	return ReadResourceResponseFromJSONTyped(json, false);
}

export function ReadResourceResponseFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): ReadResourceResponse {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		rID: json['RID'],
		state: json['state'],
	};
}

export function ReadResourceResponseToJSON(value?: ReadResourceResponse | null): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		RID: value.rID,
		state: value.state,
	};
}
